// extracted by mini-css-extract-plugin
export var button = "_kv-2";
export var card = "_kv-0";
export var closeButtonContainer = "_kv-3";
export var iconContainer = "_kv-1";